import styled from 'styled-components';
import { font, colors } from 'nicollet-tokens';
import { SelectButtonWithValidation } from '../Items/SelectBox.js';

const SelectElement = styled.select`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  background: none;
  border: 0;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  box-sizing: border-box;
  appearance: none;
  opacity: 0;
  font-size: ${font.size.text.base}; /* Value has to be at least 16px so iOS doesn't zoom */

  &:focus {
    /*
      Since the <select> is visually hidden,
      when we focus on the select element we'll add a visual indicator on the
      custom label instead
    */
    + ${SelectButtonWithValidation}, + div {
      text-decoration: underline;
      outline: 1px dashed ${colors.border.focusOutline};
      outline-offset: 2px;
    }
  }

  &:hover {
    + ${SelectButtonWithValidation}, + div {
      ${props => !props.disabled && 'text-decoration: underline'};

      /*
        Takes care of the color of the underlying box when the select is hovered to mimic
        button stylings when hovered over.
        If the SelectCustom is specifically not valid (orange) or disabled then don't add
        any background styling and if it is either primary or secondary use the respective hover color
      */
      ${({
  isValid,
  disabled,
  variant
}) => setHoverBackground(isValid, disabled, variant)}
    }
  }

  &::-ms-expand {
    display: none;
  }

  &:active {
    outline: none;
  }
`;

const setHoverBackground = (isValid, disabled, variant) => isValid === false || disabled ? '' : (variant === 'primary' || variant === 'secondary') && `background: ${colors.interactive[variant].hover};`;

export { SelectElement };
